import { infor } from '@root/state/reducers/Settlement/settlementReducer';
import { Col, Row } from 'antd';
export interface fromToInfo {
  seller: infor;
  warehouse: infor;
  admin?: infor;
  service?: boolean;
}
function FromToInforComponent({ fromToInfo }: { fromToInfo: fromToInfo }) {
  return (
    <>
      {!fromToInfo?.service && (
        <div
          style={{
            margin: '20px 0',
            width: '100%'
          }}
        >
          <Row>
            <Col span={12}>
              <div>
                <h3>From.</h3>
                <p>
                  {fromToInfo?.warehouse?.name}
                  <span style={{ marginLeft: '30px' }}>
                    {fromToInfo?.warehouse?.country}
                  </span>
                </p>

                <p>
                  <span>TEL:</span> {fromToInfo?.warehouse?.countryCode}
                  <span style={{ marginLeft: '5px' }}>
                    {fromToInfo?.warehouse?.phoneNumber}
                  </span>
                </p>
                <p>Email: {fromToInfo?.warehouse?.email} </p>
                <p className="address">
                  #{fromToInfo?.warehouse?.detailAddress}
                  <br /> {fromToInfo?.warehouse?.country}
                </p>
              </div>
            </Col>
            <Col span={12}>
              <div>
                <h3>To.</h3>
                <p>
                  {fromToInfo?.seller?.name}
                  <span style={{ marginLeft: '30px' }}>
                    {fromToInfo?.seller?.country}
                  </span>
                </p>
                <p>
                  <span>TEL:</span> {fromToInfo?.seller?.countryCode}
                  <span style={{ marginLeft: '5px' }}>
                    {fromToInfo?.seller?.phoneNumber}
                  </span>
                </p>
                <p>Email: {fromToInfo?.seller?.email} </p>
                {fromToInfo?.seller?.detailAddress && (
                  <p className="address">
                    #{fromToInfo?.seller?.detailAddress}
                    <br /> {fromToInfo?.seller?.country}
                  </p>
                )}
              </div>
            </Col>
          </Row>
        </div>
      )}

      {fromToInfo?.service && (
        <div
          style={{
            margin: '20px 0',
            width: '100%'
          }}
        >
          <Row>
            <Col span={12}>
              <div>
                <h3>From.</h3>
                <p>
                  {fromToInfo?.admin?.name}
                  <span style={{ marginLeft: '30px' }}>
                    {fromToInfo?.admin?.country}
                  </span>
                </p>
                <p>
                  <span>TEL:</span> {fromToInfo?.admin?.countryCode}
                  <span style={{ marginLeft: '5px' }}>
                    {fromToInfo?.admin?.phoneNumber}
                  </span>
                </p>
                <p>Email: {fromToInfo?.admin?.email} </p>
                {fromToInfo?.admin?.detailAddress && (
                  <p className="address">
                    #{fromToInfo?.admin?.detailAddress}
                    <br /> {fromToInfo?.admin?.country}
                  </p>
                )}
              </div>
            </Col>
            <Col span={12}>
              <div>
                <h3>To.</h3>
                <p>
                  {fromToInfo?.warehouse?.name}
                  <span style={{ marginLeft: '30px' }}>
                    {fromToInfo?.warehouse?.country}
                  </span>
                </p>
                <p>
                  <span>TEL:</span> {fromToInfo?.warehouse?.countryCode}
                  <span style={{ marginLeft: '5px' }}>
                    {fromToInfo?.warehouse?.phoneNumber}
                  </span>
                </p>
                <p>Email: {fromToInfo?.warehouse?.email} </p>
                <p className="address">
                  #{fromToInfo?.warehouse?.detailAddress}
                  <br /> {fromToInfo?.warehouse?.country}
                </p>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default FromToInforComponent;
